import { render } from "./Watermark.vue?vue&type=template&id=7f138bb5&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"

import "./Watermark.vue?vue&type=style&index=0&id=7f138bb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f138bb5"]])

export default __exports__